import React, { Component } from "react"
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from "axios"
import { Helmet } from "react-helmet"

// components
import Hero from "../components/Hero"

class Page extends Component {
	state = {
		isLoaded: false,
		campus: null,
		city: null,
		listings: []
	}

	normalizePricing = (pricing) => {
		if (typeof pricing !== "string") {
			return "$99999"
		}

		return pricing.includes("Call") || pricing.includes("call")
			? "$99999"
			: pricing
	}

	getPricingSortValue = (pricing) => {
		if (pricing === "$99999" || pricing === "") {
			return Number.MAX_SAFE_INTEGER
		}

		const numericPrice =
			typeof pricing === "string"
				? Number(pricing.replace(/[^0-9.]/g, ""))
				: Number.NaN

		return Number.isFinite(numericPrice)
			? numericPrice
			: Number.MAX_SAFE_INTEGER
	}

	logListingSource = (source, details = {}) => {
		console.info("[ApartmentListings_sp] Listing source", {
			source,
			...details
		})
	}

	normalizeSharePointListing = (element) => {
		const fields = element && element.fields

		if (!fields || fields.Campus_x002f_Location !== this.state.city) {
			return null
		}

		if (typeof fields.Title !== "string" || typeof fields.Address !== "string") {
			console.warn("[ApartmentListings_sp] Skipping malformed SharePoint listing", {
				id: fields.id,
				campus: fields.Campus_x002f_Location,
				hasTitle: typeof fields.Title === "string",
				hasAddress: typeof fields.Address === "string"
			})
			return null
		}

		const contactNumber =
			typeof fields.ContactNumber === "string" ? fields.ContactNumber : ""

		return {
			Title: fields.Title,
			Address: fields.Address,
			Category: fields.Category || "",
			ContactNumber: contactNumber,
			NumBedrooms: fields.NumberofBedrooms || "",
			DialNumber: contactNumber.replace(/[^0-9]/g, ""),
			DistancetoCampus: fields.DistancetoCampus || "",
			Pricing: this.normalizePricing(fields.Pricing),
			Website: fields.Website || null
		}
	}

	normalizeStaticListing = (listing) => ({
		Title: listing.title,
		Address: listing.address,
		Category: listing.category,
		ContactNumber: listing.phone,
		NumBedrooms: listing.numBedrooms || "",
		DialNumber: listing.phone ? listing.phone.replace(/[^0-9]/g, "") : "",
		DistancetoCampus: listing.distance,
		Pricing: this.normalizePricing(listing.price),
		Website: listing.website ? { Url: listing.website } : null
	})

	loadStaticListings = (reason = "manual-fallback") => {
		axios.get("/global/data/apartment-listings.json").then((res) => {
			const listings = res.data.listings
				.filter(
					(listing) =>
						listing.campus === this.state.campus && listing.active === true
				)
				.map(this.normalizeStaticListing)

			this.logListingSource("static", {
				reason,
				campus: this.state.campus,
				city: this.state.city,
				count: listings.length
			})

			this.setState({ listings }, this.sortByDistance)

			setTimeout(() => {
				this.setActive(this.state.campus)
			}, 25)
		})
	}

	componentDidMount() {
		window.scrollTo(0, 0)
		document.querySelector("#main").classList.add("hero")

		let url = window.location.pathname
		switch (url.split("/")[1]) {
			case "austin":
				this.setState({
					campus: "txau",
					city: "Austin",
					apartmentscom: {
						link: "https://www.apartments.com/off-campus-housing/tx/austin/university-of-st-augustine-for-health-sciences-austin-tx-campus/",
						text: "Austin, TX Apartments"
					}
				})
				break
			case "dallas":
				this.setState({
					campus: "txda",
					city: "Dallas",
					apartmentscom: {
						link: "https://www.apartments.com/off-campus-housing/tx/irving/university-of-st-augustine-for-health-sciences-dallas-tx-campus/",
						text: "Dallas, TX Apartments"
					}
				})
				break
			case "san-marcos":
				this.setState({
					campus: "casm",
					city: "San Marcos",
					apartmentscom: {
						link: "https://www.apartments.com/off-campus-housing/ca/san-marcos/university-of-st-augustine-for-health-sciences-san-marcos-ca-campus/",
						text: "San Marcos, CA Apartments"
					}
				})
				break
			case "miami":
				this.setState({
					campus: "flmi",
					city: "Miami",
					apartmentscom: {
						link: "https://www.apartments.com/off-campus-housing/fl/coral-gables/university-of-st-augustine-for-health-sciences-miami-fl-campus/",
						text: "Miami, FL Apartments"
					}
				})
				break
			case "st-augustine":
				this.setState({
					campus: "flsa",
					city: "St. Augustine",
					apartmentscom: {
						link: "https://www.apartments.com/off-campus-housing/fl/st-augustine/university-of-st-augustine-for-health-sciences-st-augustine-fl-campus/",
						text: "St. Augustine, FL Apartments"
					}
				})
				break
			default:
				return ""
		}

		setTimeout(() => {
			const SPAPI = process.env.REACT_APP_SHAREPOINTAPI
			const data = {
				usahstoken: process.env.REACT_APP_SECURITYTOKEN
			}
			const config = {
				method: "post",
				url: process.env.REACT_APP_TOKENURL,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Access-Control-Allow-Origin": "*"
				},
				data: JSON.stringify(data)
			}

			axios(config)
				.then((res) => {
					let token = res.data.access_token
					let listid = "4de34d0d-b57a-4147-b755-d07bc01ee8ae"
					axios
						.get(
							SPAPI +
								"/" +
								listid +
								"/items?expand=fields(select=id,Title,Category,Campus_x002f_Location,DistancetoCampus,ContactNumber,Pricing,Address,Website,NumberofBedrooms)",
							{
								headers: {
									Authorization: `Bearer ${token}`
								}
							}
						)
						.then((res) => {
							const listings = res.data.value
								.map(this.normalizeSharePointListing)
								.filter(Boolean)

							this.logListingSource("sharepoint", {
								campus: this.state.campus,
								city: this.state.city,
								count: listings.length
							})

							this.setState({ listings }, this.sortByDistance)

							setTimeout(() => {
								this.setActive(this.state.campus)
							}, 25)
						})
						.catch((error) => {
							console.dir(error)
							this.loadStaticListings("sharepoint-items-request-failed")
						})
				})
				.catch((error) => {
					console.dir(error)
					this.loadStaticListings("sharepoint-token-request-failed")
				})
		}, 25)
	}

	setActive = (e) => {
		document.querySelector("ol.breadcrumb ." + e).classList.add("active")
	}

	sortByDistance = () => {
		this.state.listings.sort((a, b) =>
			Number(a.DistancetoCampus) > Number(b.DistancetoCampus) ? 1 : -1
		)
		this.setState({ isLoaded: true })
	}

	sortByPricing = () => {
		this.state.listings.sort((a, b) =>
			this.getPricingSortValue(a.Pricing) >
			this.getPricingSortValue(b.Pricing)
				? 1
				: -1
		)
		this.setState({ isLoaded: true })
	}

	render() {
		const { isLoaded, campus, listings } = this.state
		const contentOnly =
			window.location.search.indexOf("contentonly") > -1 ? true : false
		const targetWindow =
			window.location.search.indexOf("contentonly") > -1 ? "_system" : "_blank"

		return (
			<>
				{isLoaded === false && (
					<div className="preloader">
						<div className="loader"></div>
					</div>
				)}

				{isLoaded && (
					<>
						<Helmet>
							<title>{campus.toUpperCase()} Apartment Listings :: USAHS</title>
							<link
								rel="canonical"
								href={window.location.href}
							/>
							<meta
								property="og:url"
								content={window.location.href}
							/>
						</Helmet>

						<Hero
							title="Apartment Listings"
							campus={campus}
						/>

						<div className="listings">
							<div className="container-fluid">
								<div className="row">
									<div className="container">
										<div className="row">
											<div className="col-12">
												{contentOnly === false && (
													<nav aria-label="breadcrumb">
														<ol className="breadcrumb">
															<li className="breadcrumb-item flsa">
																<a href="/st-augustine/apartment-listings">
																	St. Augustine, FL
																</a>
															</li>
															<li className="breadcrumb-item flmi">
																<a href="/miami/apartment-listings">
																	Miami, FL
																</a>
															</li>
															<li className="breadcrumb-item txau">
																<a href="/austin/apartment-listings">
																	Austin, TX
																</a>
															</li>
															<li className="breadcrumb-item txda">
																<a href="/dallas/apartment-listings">
																	Dallas, TX
																</a>
															</li>
															<li className="breadcrumb-item casm">
																<a href="/san-marcos/apartment-listings">
																	San Marcos, CA
																</a>
															</li>
														</ol>
													</nav>
												)}

												<p>
													These apartment listings are static pages from the
													full{" "}
													<strong>
														University of St. Augustine Student Housing Portal
													</strong>
													. Students will receive full access to the
													<strong>&nbsp;
														<a
															href="https://usahs.sharepoint.com/sites/StudentHousing"
															title="Student Housing Portal"
															target="_blank"
															rel="noreferrer"
														>
															 Student Housing Portal
														</a>
														,
													</strong>{" "}
													including the ability to post roommate requests and
													review private rental listings, once they have been
													admitted to the university and have activated their
													student email address.
												</p>

												<p>
													In addition to student recommended apartments listed
													below, find nearby available units through
													Apartments.com via this link:
													<br />
													<a
														href={this.state.apartmentscom.link}
														target="_blank"
														rel="noreferrer"
													>
														{this.state.apartmentscom.text}
													</a>
												</p>

												<div className="table-responsive">
													<table className="table table-striped">
														<thead>
															<tr>
																<th scope="col">Title</th>
																<th scope="col">Street Address</th>
																<th
																	scope="col"
																	className="center"
																>
																	Category
																</th>
																<th
																	scope="col"
																	className="center sort"
																	onClick={this.sortByDistance}
																>
																	Distance from Campus{" "}
																	<i className="fa-solid fa-caret-down"></i>
																</th>
																<th
																	scope="col"
																	className="center"
																>
																	Number of Bedrooms
																</th>
																<th
																	scope="col"
																	className="center"
																>
																	Contact Number
																</th>
																<th
																	scope="col"
																	className="sort"
																	onClick={this.sortByPricing}
																>
																	Pricing{" "}
																	<i className="fa-solid fa-caret-down"></i>
																</th>
																<th
																	scope="col"
																	className="center"
																>
																	Website
																</th>
															</tr>
														</thead>

														<tbody>
															{listings.map((l, index) => (
																<tr key={index}>
																	<td>
																		{l.Website && (
																			<>
																				<a
																					href={l.Website.Url}
																					target={targetWindow}
																					rel="noreferrer"
																				>
																					{l.Title}
																				</a>
																			</>
																		)}
																		{!l.Website && <>{l.Title}</>}
																	</td>
																	<td>
																		<a
																			href={
																				"https://www.google.com/maps/place/" +
																				l.Address
																			}
																			target={targetWindow}
																			rel="noreferrer"
																			dangerouslySetInnerHTML={{
																				__html:
																					l.Address.split(",")[0] +
																					"<br/>" +
																					l.Address.split(",")[1] +
																					"," +
																					l.Address.split(",")[2]
																			}}
																		/>
																	</td>
																	<td className="center">{l.Category}</td>
																	<td className="center">
																		{l.DistancetoCampus} miles
																	</td>
																	<td className="center">{l.NumBedrooms}</td>
																	<td className="nowrap center">
																		{l.ContactNumber && (
																			<a href={"tel:" + l.DialNumber}>
																				{l.ContactNumber}
																			</a>
																		)}
																	</td>
																	<td className="center">
																		{l.Pricing === "$99999"
																			? "Call for pricing"
																			: l.Pricing}
																	</td>
																	<td className="center">
																		{l.Website && (
																			<a
																				href={l.Website.Url}
																				target={targetWindow}
																				rel="noreferrer"
																				aria-label={l.Title}
																			>
																				<i className="fas fa-desktop-alt"></i>
																			</a>
																		)}
																	</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</>
		)
	}
}

export default Page
